import { forEach } from 'lodash'

const ACTIVE_CLASS = 'is-active'
const OPEN_CLASS = 'is-open'

const openItem = item => {
  let setTimeoutId = null

  if (!item) {
    return false
  }

  const content = document.getElementById('content')
  if (!item.classList.contains(OPEN_CLASS)) {
    item.classList.add(OPEN_CLASS)
    if (!setTimeoutId) {
      setTimeoutId = setTimeout(() => {
        if (content.scrollTop > 60) {
          content.scrollTop += 30
        }
        item.classList.add(ACTIVE_CLASS)
        setTimeoutId = null
      }, 200)
    }
  } else {
    item.classList.remove(OPEN_CLASS)
    item.classList.remove(ACTIVE_CLASS)
    if (content.scrollTop > 60) {
      content.scrollTop -= 30
    }
  }
}

const handleRowClick = row => {
  openItem(row.parentNode)
}

document.addEventListener('DOMContentLoaded', () => {
  const rows = document.getElementsByClassName('js-user-notice-item')
  forEach(rows, row => {
    row.addEventListener('click', () => handleRowClick(row))
  })

  const url = new URL(window.location.href)
  if (url.hash) {
    const item = document.querySelector(url.hash)
    if (item) {
      setTimeout(() => {
        window.scrollTo(0, item.offsetTop)
        openItem(item)
      }, 200)
    }
  }
})
